import { CssBaseline } from "@mui/material";
import { ConnectedRouter } from "connected-react-router";
import SnackbarProviderExtended from "./components/mui/messages/snackbarProviderExtended/snackbarProviderExtended.jsx"; // Customize notistack
import { PermissionsModule } from "./modules/permission";

import Main from "./pages/main/main.jsx";

import history from './store/history'

import { loadModules } from "./store/loadModule";
import ThemeCustomization from "./themes/index.jsx"; // Declare custom mui theme
import './App.css'
import {Route, Switch} from "react-router";
import NotFound from "./pages/notFound/notFound";
import {Redirect} from "react-router-dom";
import {UserProvider} from "./userContext/userContext";


// Get routes from loaded modules to get all active Routes.
export const ENABLED_MODULES = loadModules([PermissionsModule])
export const ROUTES = ENABLED_MODULES.loadRoutes()
const DEFAULT_CAMPAIGN = "apply";

function App() {
	return (
		<UserProvider>
		<ThemeCustomization>
			<SnackbarProviderExtended>
				<ConnectedRouter history={history}>
					<CssBaseline/>
					<Switch>
						<Route exact path="/">
							<Redirect to={`/${DEFAULT_CAMPAIGN}`} />
						</Route>
						<Route path="/:campaign">
							<Main />
						</Route>

						<Route path="*">
							<NotFound />
						</Route>
					</Switch>
				</ConnectedRouter>
			</SnackbarProviderExtended>
		</ThemeCustomization>
		</UserProvider>
	)
}

export default App
